<template>
  <BaseCard>
    <BaseCardBody>
      <p class="mb-4">No active facebook integration was found.</p>
      <BaseButton primary tag="a" :href="connectUrl"> Connect Facebook </BaseButton>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import Qs from 'qs';
import { accountFacebookIntegrationsClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  computed: {
    redirectUri() {
      return `http://localhost:8080/accounts/${this.accountId}/settings/integrations/facebook`;
    },
    connectUrl() {
      const baseUrl = 'https://www.facebook.com/v14.0/dialog/oauth';
      const clientId = 379989760919067;
      const scope = [
        'pages_show_list',
        'read_insights',
        'instagram_basic',
        'instagram_manage_insights',
      ].join(',');

      return `${baseUrl}?client_id=${clientId}&redirect_uri=${this.redirectUri}&scope=${scope}&response_type=token&state=some_state_param`;
    },
    response() {
      if (!this.$route.hash) {
        return {};
      }

      return Qs.parse(this.$route.hash.substring(1));
    },
  },
  created() {
    if (this.response.access_token) {
      this.storeFacebookIntegration();
    }
  },
  methods: {
    async storeFacebookIntegration() {
      try {
        await accountFacebookIntegrationsClient.store(this.accountId, {
          access_token: this.response.access_token,
        });

        this.$emit('connected');
      } catch (error) {
        //
      }
    },
  },
};
</script>
